import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import React from "react";

import { ProductComparisonSection } from "@swo/storefront";
import { SectionHeadline } from "./SectionHeadline";
import { RowAttributes } from "./RowAttributes";

export const AttributeSection: ReactTFC<
  ProductComparisonSection & { selectedProductKeys: Array<string>; mode: "all" | "differences-only" }
> = props => {
  const { selectedProductKeys, mode, ...sectionProps } = props;

  return (
    <>
      <SectionHeadline groupKey={props.__key} headline={props.headline} selectedProductKeys={selectedProductKeys} />
      <RowAttributes sectionProps={sectionProps} mode={props.mode} selectedProductKeys={selectedProductKeys} />
    </>
  );
};
